import { QUESTIONS } from "./questions"
import { getReviewResult } from "./storage"

// ============================================================
// EXPORT
// Snapshots the operator's decisions on the current set of unverified
// questions so they can be applied to the per-section JSON files
// during reconciliation.
// ============================================================

function triggerDownload(filename: string, content: string, mime: string) {
  const blob = new Blob([content], { type: mime })
  const url = URL.createObjectURL(blob)
  const a = document.createElement("a")
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}

export function exportVerifyResults() {
  const unverified = QUESTIONS.filter((q) => q.status === "unverified")
  const decided = unverified.filter((q) => getReviewResult(q) !== null)
  const payload = {
    buildVersion: BUILD_VERSION,
    exportedAt: new Date().toISOString(),
    counts: {
      unverified: unverified.length,
      decided: decided.length,
    },
    questions: unverified.map((q) => ({
      ...q,
      reviewResult: getReviewResult(q),
    })),
  }
  const stamp = new Date().toISOString().slice(0, 10)
  triggerDownload(`verify-results-${stamp}.json`, JSON.stringify(payload, null, 2), "application/json")
}
